import { nonReactSetDefaultRealTimeStoreValues } from '@hotjar/webapp/features/Playbacks/store/realTimeStore';
import { cancelNextRecordingCountdown } from './cancelNextRecordingCountdown';
import { initialize as initializePlayer } from './initialize';
import { pause } from './pause';
import { Store } from '../../../store/player/types';
import { cancelOpenWorthWatchingTooltipCountdown } from './cancelShowWorthWatchingTooltipIfNotSeen';

export const resetPlayer = (store: Store): void => {
  const { reset, recording } = store.getState();

  // Clear Timeouts
  pause(store);
  cancelNextRecordingCountdown(store);
  cancelOpenWorthWatchingTooltipCountdown(store);

  // Remove existing iframes
  if (recording) {
    window.iframeController.clearIframesForRecording(recording);
  }

  // Reset stores
  reset(store.getState());
  nonReactSetDefaultRealTimeStoreValues();

  // Renitialize the player with update stores
  initializePlayer(store);
};
